<template>
    <div class="order-box-left">
        <div class="top-search item">
            <div class="label">订单筛选</div>
            <div style="width: 100%; margin-top: 8px">
                <vs-button
                        @click="emptySearch"
                        type="border"
                        size="small"
                        class="search-btn"
                >清空</vs-button
                >
                <vs-button
                        @click="handleSearch"

                        size="small"
                        class="search-btn query-btn"
                >查询</vs-button
                >
            </div>
        </div>

        <div class="order-number item">
            <!-- <div class="label">客户编码</div> -->
            <!-- <v-select
              v-model="val1"
              :options="options"
              :reduce="(opt) => opt.value"
              placeholder="请选择"
              class="select-wrap"
              @change="onChange1(val1)"
            >
            </v-select> -->
            <selectPara
                    :options="options"
                    v-model="val1"
                    @selectVal="selectVal"
                    style="width: 100%"
                    size="medium"
            ></selectPara>
            <div class="e-input">
                <!-- <el-input
                  v-if="val1 == 'khbm'"
                  size="medium"
                  v-model="selectTJ.customerCode"
                  placeholder="客户编码"
                ></el-input> -->
                <search-input v-if="val1 == 'khbm'" style="width:100%" ref="bookmarkAutoSellerCode" :autoFocus="false" :data="userInfoList" placeholder="请输入客户编码"
                              inputClassses="buyer-full" show-action show-pinned hideGroupTitle background-overlay
                              remainInputValue showName="outCode" @input="getClientInfoList" @selected="addSelectSellerCode" />
                <el-input
                        v-if="val1 == 'khmc'"
                        size="medium"
                        placeholder="客户名称"
                        v-model="selectTJ.customerName"
                ></el-input>
            </div>
        </div>

        <div class="timer item">
            <div class="label">申请日期</div>
            <flat-pickr
                    style="margin-top: 5px"
                    :config="flatPickerConfig"
                    v-model="selectTJ.beginDate"
                    placeholder="开始时间"
                    @on-change="onChange"
            />
            <flat-pickr
                    style="margin-top: 10px"
                    :config="flatPickerConfig"
                    v-model="selectTJ.endDate"
                    placeholder="结束时间"
                    @on-change="onChange"
            />
        </div>
        <div class="order-number item">
            <div class="label">开票主体</div>
            <v-select
                    v-model="selectTJ.bodyId"
                    :options="bodyTypeOptions"
                    :reduce="(opt) => opt.id"
                    placeholder="请选择"
                    class="select-wrap"
            >
                <div slot="no-options">暂无选项</div>
            </v-select>
        </div>
        <!--开票状态-->
        <div class="order-number item" style="padding-top: 0">
            <div class="label">开票状态</div>
            <el-select  style="width: 100%" v-model="selectTJ.invoiceStatus" placeholder="请选择">
                <el-option v-for="item in statusList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
            </el-select>
        </div>
        <!--开票类型-->
        <div class="order-number item" style="padding-top: 0">
            <div class="label">开票类型</div>
            <el-select  style="width: 100%" v-model="selectTJ.invoiceType" placeholder="请选择">
                <el-option label="普通发票"  value="1">普通发票</el-option>
                <el-option label="增值税发票"  value="2">增值税发票</el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    import SearchInput from '@/modules/wms-manage/components/searchInput.vue';
    import { OrderApi } from '@/modules/server-api/commodity-sys/order';
    import selectPara from "@/components/selectPara";
    import { FundManageApi } from "@/modules/server-api/fund/manage";
    import store from "@/modules/order/store.js";
    import "flatpickr/dist/flatpickr.css";
    import { Mandarin } from "flatpickr/dist/l10n/zh.js";
    import flatPickr from "vue-flatpickr-component";
    export default {
        props: {},
        components: {
            flatPickr,
            selectPara,
            SearchInput
        },
        // props: {
        //   dealerTypeList: Array,
        //   required: true
        // },
        mixins: [store],

        data() {
            return {
                statusList:[
                    {
                        value:'TO_REVIEWED',
                        label:'待确认',
                    },
                    {
                        value:'CANCEL',
                        label:'已取消',
                    },
                    {
                        value:'TO_INVOICED',
                        label:'待开票',
                    },
                    {
                        value:'INVOICED',
                        label:'已开票',
                    },
                ],//开票状态
                buyerSortList: [], //物料编码
                userInfoList: [], //用户信息列表
                val1: "khbm",
                options: [
                    { label: "客户编码", value: "khbm" },
                    { label: "客户名称", value: "khmc" },
                ],
                flatPickerConfig: {
                    locale: Mandarin, //日期控件中文
                },
                bodyTypeOptions: [], //主体
                typeOptions: [],
                categoryOptions: [],
                selectTJ: {
                    beginDate: "",
                    endDate: "",
                    bodyId: "",//开票主体
                    invoiceStatus: [], //开票状态
                    customerCode: "",//客户编码
                    customerName: "",//客户名称
                    invoiceType: "",//开票类型
                },
            };
        },
        created() {
            this.getQueryData();
            this.getOrderWayList();
        },
        async mounted() {
            this.getAccountSec();
        },
        methods: {
            // 选择卖家客户编码
            addSelectSellerCode(item){
                this.selectTJ.customerCode = item.outCode;
                console.log(item);
            },
            // 选择门店编码
            addSelectStore(item){
                this.selectTJ.storeCode = item.outCode;
            },
            // 模糊搜索门店编码
            async getStoreInfoList(e){
                this.buyerSortList = []
                let suggest = e;
                let params = {
                    pageNo: 1,
                    pageSize: 20,
                    data: {
                        outCode: suggest
                    }
                }
                let res = await OrderApi.getStoreInfoList(params);
                console.log(res);
                if(res.result && res.result.list){
                    this.buyerSortList = res.result.list;
                }
            },
            // 模糊搜索客户编码
            async getClientInfoList(e){
                console.log(e);
                this.userInfoList = [];
                let suggest = e;
                let params = {
                    pageNo: 1,
                    pageSize: 20,
                    data: {
                        outCode: suggest
                    }
                }
                let res = await OrderApi.getClientInfoList(params);
                console.log(res);
                if(res.result && res.result.list){
                    this.userInfoList = res.result.list;
                }
            },
            selectVal(e) {
                if (e == "khbm") {
                    this.selectTJ.storeCode = "";
                    this.selectTJ.storeName = "";
                    this.selectTJ.customerName = "";
                } else if (e == "khmc") {
                    this.selectTJ.storeCode = "";
                    this.selectTJ.storeName = "";
                    this.selectTJ.customerCode = "";
                } else if (e == "mdbm") {
                    this.selectTJ.storeName = "";
                    this.selectTJ.customerName = "";
                    this.selectTJ.customerCode = "";
                } else {
                    this.selectTJ.storeCode = "";
                    this.selectTJ.customerName = "";
                    this.selectTJ.customerCode = "";
                }
                console.log(e);
            },
            //获取主体列表
            async getAccountSec() {
                let that = this,
                    params = {};
                params = {
                    userId: "",
                    bodyId: "",
                };
                let resp = await FundManageApi.editManageAccount(params);
                if (resp.code == 0 && resp.succ == 1) {
                    let result = resp.result;
                    result.sdMainBodies.map((item) => {
                        item.label = item.name;
                    });
                    that.bodyTypeOptions = result.sdMainBodies;
                }
            },
            onChange(val) {
                this.$emit("onChangeTime");
            },
            emptySearch() {
                this.selectTJ.beginDate = "";
                this.selectTJ.endDate = "";
                this.selectTJ.bodyId = "";
                this.selectTJ.sourceChannel = []; //订单渠道
                this.selectTJ.storeCode = "";
                this.selectTJ.storeName = "";
                this.selectTJ.customerCode = "";
                this.selectTJ.customerName = "";
                this.selectTJ.invoiceStatus = "";
                this.selectTJ.invoiceType = "";
                this.userInfoList = [];
                this.$nextTick(()=>{
                    this.$refs['bookmarkAutoSellerCode'].searchQuery ='';
                })
                this.$emit("emptySearch")
            },
            handleSearch() {
                // console.log("查询条件", this.selectTJ);
                this.$emit("search", this.selectTJ);
            },
            getQueryData() {},
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/modules/order/order.scss";
    /deep/ .el-date-editor {
        width: 170px;
    }
    .order-box-left {
        background: rgb(255, 255, 255);
        width: 246px;
        height: 100%;

        .top-search {
            display: block !important;
            height: 80px;
            border-bottom: 1px solid rgb(235, 234, 234);
        }

        /deep/ .v-select {
            width: 100%;
        }

        .order-number {
            height: 120px;
            /deep/ .vs-input-primary{
                width: 220px;
            }
        }

        .timer {
            width: 100%;

            .flatpickr-input {
                width: 100%;
            }
        }

        .collapse {
            /deep/ .vs-collapse-item {
                border: none !important;

                .vs-collapse-item--header {
                    padding: 12px 0 !important;
                }

                .con-content--item {
                    padding: 0;
                }
            }
        }

        .item {
            padding: 12px;
        }

        .label {
            font-size: 14px;
            font-weight: 500;
            color: #14151b;
        }

        .form-item {
            width: 100%;
            height: 38px;
        }
    }

    .search-btn {
        padding: 5px 8px !important;
        width: 46%;
        margin: 0 2%;
    }
    .medium-box {
        width: 180px !important;
    }
    .flex-box {
        display: flex;
    }
    .e-input {
        margin-top: 10px;
    }
</style>
